var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSiShieldTipFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8133 36.6334C19.9388 36.6778 20.0638 36.6778 20.1883 36.6334C21.8066 36.0834 33.3333 31.6967 33.3333 18.7551V7.1734C33.3336 7.02445 33.2841 6.87967 33.1926 6.76216C33.101 6.64465 32.9728 6.56118 32.8283 6.52506L20.1616 3.3534C20.0555 3.32686 19.9444 3.32686 19.8383 3.3534L7.17163 6.52506C7.02712 6.56118 6.89888 6.64465 6.80735 6.76216C6.71582 6.87967 6.66628 7.02445 6.66663 7.1734V18.7534C6.66663 31.5651 18.1983 36.0651 19.8133 36.6334ZM21.68 11.6667C21.68 12.1088 21.5044 12.5327 21.1918 12.8452C20.8792 13.1578 20.4553 13.3334 20.0133 13.3334H20C19.5579 13.3334 19.134 13.1578 18.8214 12.8452C18.5089 12.5327 18.3333 12.1088 18.3333 11.6667C18.3333 11.2247 18.5089 10.8008 18.8214 10.4882C19.134 10.1757 19.5579 10.0001 20 10.0001H20.0133C20.4553 10.0001 20.8792 10.1757 21.1918 10.4882C21.5044 10.8008 21.68 11.2247 21.68 11.6667ZM20.0133 26.6667C19.5713 26.6667 19.1473 26.4911 18.8348 26.1786C18.5222 25.866 18.3466 25.4421 18.3466 25.0001V16.6667C18.3466 16.2247 18.5222 15.8008 18.8348 15.4882C19.1473 15.1757 19.5713 15.0001 20.0133 15.0001C20.4553 15.0001 20.8792 15.1757 21.1918 15.4882C21.5044 15.8008 21.68 16.2247 21.68 16.6667V25.0001C21.68 25.4421 21.5044 25.866 21.1918 26.1786C20.8792 26.4911 20.4553 26.6667 20.0133 26.6667Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiShieldTipFill);
export default __webpack_public_path__ + "static/media/si_shield-tip-fill.0e21dcd63478e570b1b8b677e142b20c.svg";
export { ForwardRef as ReactComponent };